<template>
    <div>
        <div v-if="pconUrl">
            <button data-target="#pcon" data-toggle="modal" class="single__add-to-basket-btn pcon">
                {{ $translate("Weberbuero::Template.pconModalButton") }}
            </button>
            <div id="pcon-wrapper">
                <div class="modal fade" id="pcon" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="modal-title h3">
                                    {{ $translate("Weberbuero::Template.pconModalTitle") }}
                                </div>
                                <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span
                                        aria-hidden="true">×</span></button>
                            </div>
                            <div class="modal-body">
                                <client-only>
                                    <pcon-configurator :item-id="currentVariation.item.id"></pcon-configurator>
                                </client-only>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <add-to-basket v-if="currentVariation" :variation-id="currentVariation.variation.id"
                :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                :order-properties="currentVariation.properties.filter(function (prop) { return prop.property.isOderProperty })"
                :has-order-properties="currentVariation.hasOrderProperties"
                :has-required-order-property="currentVariation.hasRequiredOrderProperty" :use-large-scale="false"
                :show-quantity="true" :item-url="currentVariation | itemURL"
                :has-price="currentVariation | hasItemDefaultPrice" :button-size="buttonSize"
                :padding-classes="paddingClasses" :padding-inline-styles="paddingStyles" focus-select>
            </add-to-basket>
        </div>
    </div>
</template>

<script>
import AddToBasket from "../basket/AddToBasket.vue";

export default {
    name: "single-add-to-basket",

    components: {
        AddToBasket
    },

    props: {
        buttonSize: String,
        paddingClasses: String,
        paddingStyles: String
    },

    inject: {
        itemId: {
            default: null
        }
    },

    computed: {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },

        pconUrl() {
            let part1 = ""
            for (let key in this.currentVariation.variationProperties) {
                for (let key2 in this.currentVariation.variationProperties[key].properties) {
                    if (this.currentVariation.variationProperties[key].properties[key2].id === 255) {
                        part1 = this.currentVariation.variationProperties[key].properties[key2].values.value;
                    }
                }
            }
            if (part1 === "") {
                return "";
            } else if (this.isPreview) {
                return "https://ui.pcon-solutions.com/#GATEKEEPER_ID=65e6c3945d3b2&moc=NARFC&ban=DJT101&sid=QACTIVE&ovc=MG2012.FrameAndLegColour%3DA%3BMG2012.Columns%3D333%3BMG2012.MetalFeet%3DF%3BMG2012.PowerPlug%3DEU%3BMG2012.Button%3DUA&lang=de&sp=true&HOOK_URL=https://wbconnect.de/plenty/set-variation/10359";
            } else {
                return part1 + this.itemId;
            }
        }
    }
}
</script>
